<template>
  <div :class="classObj" class="app-wrapper">
    <div :class="{ 'fixed-header': fixedHeader }">
      <navbar />
    </div>
      <sidebar class="sidebar-container" />
      <div class="main-container">
        <tags />
        <app-main />
      </div>
      <app-foot  /> 
  </div>
</template>
<script>
import { Navbar, Sidebar, AppMain, Tags,AppFoot } from './components'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    Tags,
    AppFoot
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
       
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';

.app-content{
float: left;
width: 100%;
}
.app-wrapper {
  height: 100%;
  width: 100%;
  background-color:#F1F2F2 ;
 
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}


</style>
